export enum APP_NAME {
  Bridesmaid = 'Bridesmaid',
  DressFinder = 'Dressfinder',
  VisionBoard = 'Visionboard',
}
